/**
 * Retreives location boundaries and adds them to the map.
 * @param locationBoundaryMapLayer  the layer to add locations to
 */
define(['jquery', 'bing', 'c21/ajax', 'c21/results'], function ($, BingMaps, ajax, results) {
   "use strict";

   return function (locationBoundaryMapLayer) {
      var self = this,

         m_xhr,

         // The last query info
         m_lastBounds,
         m_lastLocationIds,

         addData = function (data) {
            var aLatLon = [];

            locationBoundaryMapLayer.clearLocationBoundaryMap();

            if (data) {
               // For each location
               $.each(data.locations, function (strLocationName, loc) {
                  // For each polygon
                  $.each(loc.polygons, function (i, polygon) {
                     // This would be the pretty way of doing it
                     var aPoints = polygon.split("|"),
                        aPolyLatLon = [];

                     // For each set of points
                     $.each(aPoints, function (i, strPoint) {
                        var aPointParts = strPoint.split(","),
                           strLatitude = aPointParts[1],
                           strLongitude = aPointParts[0],
                           fLatitude = parseFloat(strLatitude),
                           fLongitude = parseFloat(strLongitude),
                           loc = new BingMaps.Location(fLatitude, fLongitude);

                        aPolyLatLon.push(loc);
                        aLatLon.push(loc);
                     });

                     locationBoundaryMapLayer.addMapLocation(aPolyLatLon, strLocationName);
                  });
               });
            }

            return aLatLon;
         };

      self.getData = function (bounds, locationIds, settings) {
         var options = settings || {},
            data = options.data || {};

         if (m_lastBounds && m_lastLocationIds) {
            if ((JSON.stringify(m_lastBounds) === JSON.stringify(bounds)) && (locationIds === m_lastLocationIds)) {
               return;
            }
         }

         m_lastBounds = bounds;
         m_lastLocationIds = locationIds;

         if (m_xhr) {
            m_xhr.abort();
         }

         m_xhr = ajax.fetch({
            cache: false,
            dataType: "json",
            data: $.extend({
               lids: locationIds,
               zoom: bounds.zoom + 3,
               px: results.getMapBoundaries(bounds),
               submitted: true,
               subView: "LocationBoundaryMapSearch"
            }, data),
            url: "/locationboundary/",
            success: function (data) {
               var aLatLon = addData(data);

               if (options.success) {
                  options.success(aLatLon);
               }
            },
            error: function (jqXHR, textStatus, errorThrown) {
               //alert('error');
            }
         });
      };

      self.cancel = function () {
         if (m_xhr) {
            m_xhr.abort();
         }
      };
   };
});
